import ShoplusManageProductInfo from "../views/shoplus_authservice/ManageProductInfo.vue";
import ShoplusServiceIntro from "../views/shoplus_authservice/ServiceIntro.vue";
import ShoplusWarrantyPeriod from "../views/shoplus_authservice/WarrantyPeriod.vue";
import ShoplusCreateAuthcode from "../views/shoplus_authservice/CreateAuthcode.vue";
import ShoplusManageAuthcode from "../views/shoplus_authservice/ManageAuthcode.vue";
import ShoplusPrintqr from "../views/shoplus_authservice/Printqr.vue";
import ShoplusSetting from "../views/shoplus_authservice/Setting.vue";
import ShoplusPayment from "../views/shoplus_authservice/Payment.vue";
import ShoplusAdditionalService from "../views/shoplus_authservice/AdditionalService.vue";
import ShoplusAuthService from "../views/shoplus_service/AuthService.vue";
import ShoplusAuthServicePartners from "../views/shoplus_service/Login.vue";
import ShoplusAuthServicePartnersFindId from "../views/shoplus_service/FindId.vue";
import ShoplusAuthServicePartnersFindPassword from "../views/shoplus_service/FindPassword.vue";
import ShoplusAuthServicePartnersPassWordReSet from "../views/shoplus_service/PassWordReSet.vue";
import ShoplusAuthServicePartnersSignUpMembership from "../views/shoplus_service/SignUpMembership.vue";

export const SHOPLUS_ROUTES = [
  {
    path: "/shoplus_authservice/:mall_id/serviceIntro",
    name: "ShoplusServiceIntro",
    component: ShoplusServiceIntro,
    props: true,
  },
  {
    path: "/shoplus_authservice/:mall_id/manageProductInfo",
    name: "ShoplusManageProductInfo",
    component: ShoplusManageProductInfo,
    props: true,
  },
  {
    path: "/shoplus_authservice/:mall_id/warrantyPeriod",
    name: "ShoplusWarrantyPeriod",
    component: ShoplusWarrantyPeriod,
    props: true,
  },
  {
    path: "/shoplus_authservice/:mall_id/createAuthcode",
    name: "ShoplusCreateAuthcode",
    component: ShoplusCreateAuthcode,
    props: true,
  },
  {
    path: "/shoplus_authservice/:mall_id/manageAuthcode",
    name: "ShoplusManageAuthcode",
    component: ShoplusManageAuthcode,
    props: true,
  },
  {
    path: "/shoplus_authservice/:mall_id/printqr",
    name: "ShoplusPrintqr",
    component: ShoplusPrintqr,
    props: true,
  },
  {
    path: "/shoplus_authservice/:mall_id/setting",
    name: "ShoplusSetting",
    component: ShoplusSetting,
    props: true,
  },
  {
    path: "/shoplus_authservice/:mall_id/payment",
    name: "ShoplusPayment",
    component: ShoplusPayment,
    props: true,
  },
  {
    path: "/shoplus_authservice/:mall_id/additionalService",
    name: "ShoplusAdditionalService",
    component: ShoplusAdditionalService,
    props: true,
  },
  {
    path: "/shoplus_service/:mall_id/authservice",
    name: "ShoplusAuthService",
    component: ShoplusAuthService,
    props: true,
  },
  {
    path: "/shoplus_authservice_partners",
    name: "ShoplusAuthServicePartners",
    component: ShoplusAuthServicePartners,
    props: true,
    meta: {
      group: "ShoplusAuthServicePartners",
    },
  },
  {
    path: "/shoplus_service/findId",
    name: "ShoplusAuthServicePartnersFindId",
    component: ShoplusAuthServicePartnersFindId,
    props: true,
    meta: {
      group: "ShoplusAuthServicePartners",
    },
  },
  {
    path: "/shoplus_authservice_partners/findPassword",
    name: "ShoplusAuthServicePartnersFindPassword",
    component: ShoplusAuthServicePartnersFindPassword,
    props: true,
    meta: {
      group: "ShoplusAuthServicePartners",
    },
  },
  {
    path: "/shoplus_authservice_partners/passwordReset",
    name: "ShoplusAuthServicePartnersPassWordReSet",
    component: ShoplusAuthServicePartnersPassWordReSet,
    props: true,
    meta: {
      group: "ShoplusAuthServicePartners",
    },
  },
  {
    path: "/shoplus_authservice_partners/signUpMembership",
    name: "ShoplusAuthServicePartnersSignUpMembership",
    component: ShoplusAuthServicePartnersSignUpMembership,
    props: true,
    meta: {
      group: "ShoplusAuthServicePartners",
    },
  },
];
